import {
  createFileRoute,
  useSearch,
  useNavigate,
  Navigate,
} from "@tanstack/react-router";
import { z } from "zod";
import { useAuth } from "@/hooks/useAuth";
import { LocationListing } from "@/components/locations";

const locationsSearchSchema = z.object({
  page: z.number().catch(1),
  pageSize: z.number().catch(50),
  search: z.string().optional(),
  sortBy: z.string().optional(),
  sortOrder: z.enum(["asc", "desc"]).optional(),
  status: z.enum(["all", "active", "inactive"]).catch("all"),
});

export const Route = createFileRoute("/(protected)/_layout/_org/locations/")({
  validateSearch: (search) => locationsSearchSchema.parse(search),
  component: LocationsTab,
});

function LocationsTab() {
  const { hasPermission, isLoading } = useAuth();
  const searchParams = useSearch({
    from: "/(protected)/_layout/_org/locations/",
  });
  const navigate = useNavigate();

  if (!isLoading && !hasPermission("location:read")) {
    return (
      <Navigate
        to="/unauthorized"
        search={{
          reason: "permission_denied",
          from: "/locations",
          requiredPermission: "location:read",
        }}
        replace
      />
    );
  }

  return (
    <LocationListing
      searchParams={searchParams}
      onNavigate={(updater) =>
        void navigate({
          from: "/locations/",
          search: updater,
          replace: true,
        })
      }
    />
  );
}
